import { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import { Button, Modal, Form } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";

import { getAuthorizationToken } from "@/auth/tokenStore";

import { addClickRecord, formatDateForPanelDisplay, getClientId } from "../../../Utils/helper";
// import avatar from "../../../../public/bp_assets/img/avatar_new.svg";
import SignaturePreview from "../../FirmSettings/email-signature/SignaturePreview";
import UserChatBubble from "../../Forms/FirmUserBtn";

import avatarImage from "./../../../assets/images/avatar.svg";
const toPreviewProps = (sig) => ({
  logoURL: sig?.logo_url,
  logoType: sig?.logoType,
  userId: sig?.id,
  userName:
    sig?.for_staff === null
      ? sig?.for_firm?.attorneyprofile?.office_name
      : `${sig?.for_staff?.user?.first_name} ${sig?.for_staff?.user?.last_name}`,
  userTitle: "",
  ...(sig?.use_office_contact ? sig?.office_address : sig?.for_address),
});

const EmailReplyModal = ({
  handleClose,
  show,
  email,
  refetchEmails,
  refetchUnreadCount,
  client_pic,
  clientName,
  client_email,
}) => {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const token = getAuthorizationToken();
  const clientId = getClientId();
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const [subject, setSubject] = useState(`Re: ${email?.subject || ""}`);
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentUserSig, setCurrentUserSig] = useState({});
  const [signatureType, setSignatureType] = useState("individual");
  const [selectedSignatureId, setSelectedSignatureId] = useState(null);
  const [loading2, setLoading2] = useState(false);
  useEffect(() => {
    const fetchSignatures = async () => {
      try {
        setLoading2(true);
        const res = await axios.get(
          `${origin}/api/firmsetting-page/email-signature/current-user/`,
          { headers: { Authorization: token } }
        );
        setCurrentUserSig(res.data || {});
      } catch (err) {
        console.error("Error fetching email signatures:", err);
      } finally {
        setLoading2(false);
      }
    };
    if (show) fetchSignatures();
  }, [show]);

  useEffect(() => {
    const sig =
      signatureType === "firm" ? currentUserSig?.firm_signature : currentUserSig?.staff_signature;
    setSelectedSignatureId(sig?.id ?? null);
  }, [signatureType, currentUserSig]);

  useEffect(() => {
    if (!currentUserSig?.staff_signature && !loading2) {
      setSignatureType("firm");
    }
    if (!currentUserSig?.firm_signature && !loading2) {
      setSignatureType("individual");
    }
  }, [currentUserSig, loading2]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const url = `${origin}/api/client-page/send-email-to-client/${clientId}/`;
      const requestData = {
        to: email?.sender,
        subject: subject,
        body: body,
        parent_email_id: email?.id,
        email_signature_id: selectedSignatureId,
      };

      await axios.post(url, requestData, {
        headers: {
          Authorization: token,
        },
      });

      setLoading(false);
      refetchEmails();
      refetchUnreadCount();
      handleClose();
    } catch (error) {
      console.error("Error sending email reply:", error);
      setLoading(false);
      alert("Error sending email, please try again.");
    }
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="Law-firm-direct-max-width-800px"
      aria-labelledby="emailReplyModalLabel"
      centered
    >
      <Modal.Header className="modal-header text-center p-0 bg-primary popup-heading-color justify-content-center">
        <h5
          className="modal-title mx-auto d-flex align-items-center justify-content-center height-25 font-weight-semibold text-uppercase popup-heading-color font-weight-500"
          id="emailReplyModalTitle"
          style={{
            fontSize: "14px",
            gap: "5px",
          }}
        >
          Reply to{" "}
          {client_pic ? (
            <div className="ic d-flex align-items-center justify-content-center">
              <img
                style={{
                  minWidth: "15px",
                }}
                className={"ic-15 theme-ring"}
                src={client_pic}
                alt="Profil"
              />
            </div>
          ) : (
            <div className="ic d-flex align-items-center justify-content-center">
              <img
                style={{
                  minWidth: "15px",
                  background: "var(--primary-30)",
                }}
                className={"ic-15 theme-ring"}
                src={avatarImage}
              />
            </div>
          )}{" "}
          {clientName}
        </h5>
      </Modal.Header>
      <Modal.Body style={{ height: "max-content", padding: "0px" }}>
        <div style={{ padding: "5px" }}>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-align-items-center">
              <h5
                className="m-b-5 d-flex align-items-center"
                style={{
                  gap: "5px",
                }}
              >
                <div className="d-flex align-items-center justify-content-end">
                  <span
                    className="text-end"
                    style={{
                      minWidth: "73px",
                      color: "var(--primary-25)",
                    }}
                  >
                    Recieved:
                  </span>
                </div>
                <span
                  className=" m-r-5"
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {formatDateForPanelDisplay(email?.date_received)}
                  <b
                    className="text-lowercase p-l-5"
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    {new Date(email?.date_received).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </b>
                </span>
              </h5>
            </div>
            <div className="d-flex justify-content-between align-align-items-center">
              <h5
                className="m-b-5 d-flex align-items-center"
                style={{
                  gap: "5px",
                }}
              >
                <div className="d-flex align-items-center">
                  <span
                    className="text-end"
                    style={{
                      minWidth: "73px",
                      color: "var(--primary-25)",
                    }}
                  >
                    From:
                  </span>
                </div>
                <div
                  className="d-flex"
                  style={{
                    fontWeight: "600",
                  }}
                >
                  <div className="d-flex pe-1">
                    {email?.sent_by_user?.user_type === "Client" ? (
                      <>
                        {client_pic ? (
                          <div className="ic  d-flex align-items-center justify-content-center pe-1">
                            <img
                              style={{
                                minWidth: "15px",
                              }}
                              className={"ic-15 theme-ring"}
                              src={client_pic}
                              alt="Profil"
                            />
                          </div>
                        ) : (
                          <div className="ic  d-flex align-items-center justify-content-center pe-1">
                            <img
                              style={{
                                minWidth: "15px",
                                background: "var(--primary-30)",
                              }}
                              className={"ic-15 theme-ring"}
                              src={avatarImage}
                            />
                          </div>
                        )}{" "}
                        {clientName}
                      </>
                    ) : (
                      <UserChatBubble
                        userId={email?.sent_by_user?.id}
                        first_name={email?.sent_by_user?.first_name || ""}
                        last_name={email?.sent_by_user?.last_name || ""}
                        profilePic={email?.sent_by_user?.profile_pic ?? ""}
                        isActive={false}
                        is_active={email?.sent_by_user?.is_active}
                        width={19}
                      />
                    )}
                  </div>
                  {email?.sender}
                </div>
              </h5>
            </div>
          </div>

          <div>
            <div className="d-flex m-b-5">
              <h5
                className="m-b-5 d-flex align-items-center"
                style={{
                  gap: "5px",
                }}
              >
                <div className="d-flex align-items-center">
                  <span
                    className="text-end"
                    style={{
                      minWidth: "73px",
                      color: "var(--primary-25)",
                    }}
                  >
                    Subject:
                  </span>
                </div>
              </h5>
              <div
                className="px-1 m-l-5 w-100 d-flex align-items-center py-0"
                style={{
                  backgroundColor: "var(--primary-4)",
                  // border: "1px solid #dee2e6",
                  // borderRadius: "4px",
                  height: "25px",
                  cursor: "not-allowed",
                }}
              >
                {email?.subject}
              </div>
            </div>
            <div className="d-flex m-b-5">
              <h5 className="d-flex align-items-start">
                <div className="d-flex align-items-center">
                  <span
                    className="text-end"
                    style={{
                      minWidth: "73px",
                      color: "var(--primary-25)",
                    }}
                  >
                    Email:
                  </span>
                </div>
              </h5>
              <div
                className="px-1 m-l-5 w-100 d-flex align-items-start py-0"
                style={{
                  backgroundColor: "var(--primary-4)",
                  // border: "1px solid #dee2e6",
                  // borderRadius: "4px",
                  minHeight: "25px",
                  maxHeight: "200px",
                  overflowY: "auto",
                  cursor: "not-allowed",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(email?.body || "") }}
                  style={{ width: "100%", maxHeight: "200px", overflow: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-100 text-center bg-primary popup-heading-color">
          <h5
            className="mx-auto d-flex align-items-center justify-content-center height-25 text-uppercase popup-heading-color font-weight-500"
            style={{
              fontSize: "14px",
            }}
          >
            REPLY TO CLIENT EMAIL
          </h5>
        </div>
        <div style={{ padding: "5px" }}>
          <div className="d-flex align-align-items-center">
            <h5
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <div className="d-flex align-items-center m-b-5">
                <span
                  className="text-end"
                  style={{
                    minWidth: "73px",
                    color: "var(--primary-25)",
                  }}
                >
                  To:
                </span>
              </div>
              <div
                className="d-flex"
                style={{
                  fontWeight: "600",
                }}
              >
                <div className="d-flex pe-1">
                  {client_pic ? (
                    <div className="ic  d-flex align-items-center justify-content-center pe-1">
                      <img
                        style={{
                          minWidth: "15px",
                        }}
                        className={"ic-15 theme-ring"}
                        src={client_pic}
                        alt="Profil"
                      />
                    </div>
                  ) : (
                    <div className="ic  d-flex align-items-center justify-content-center pe-1">
                      <img
                        style={{
                          minWidth: "15px",
                          background: "var(--primary-30)",
                        }}
                        className={"ic-15 theme-ring"}
                        src={avatarImage}
                      />
                    </div>
                  )}{" "}
                  {clientName}
                </div>
                {client_email}
              </div>
            </h5>
          </div>
          <Form.Group className="m-b-5 d-flex">
            <h5
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <div className="d-flex align-items-center">
                <span
                  className="text-end"
                  style={{
                    minWidth: "73px",
                    color: "var(--primary-25)",
                  }}
                >
                  Subject:
                </span>
              </div>
            </h5>
            <Form.Control
              className="py-0 m-l-5 height-25"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter subject"
            />
          </Form.Group>
          <Form.Group className="m-b-5 d-flex">
            <h5
              className="d-flex align-items-center"
              style={{
                gap: "5px",
              }}
            >
              <div className="d-flex align-items-center">
                <span
                  className="text-end"
                  style={{
                    minWidth: "73px",
                    color: "var(--primary-25)",
                  }}
                >
                  Reply:
                </span>
              </div>
            </h5>
            <Form.Control
              className="py-0 m-l-5"
              style={{ height: "100px", overflowY: "auto" }}
              as="textarea"
              rows={5}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder="Enter your reply message"
            />
          </Form.Group>

          <div
            className="d-flex justify-content-between"
            style={{
              gap: "5px",
            }}
          >
            <div
              style={{
                width: "50%",
              }}
              className=" d-flex flex-column flex-g-1 justify-content-start"
            >
              <span className="d-flex align-items-center me-2">
                <input
                  type="radio"
                  id="reply-sig-individual"
                  name="replySignatureType"
                  disabled={!currentUserSig?.staff_signature}
                  checked={signatureType === "individual"}
                  onChange={() => setSignatureType("individual")}
                />
                <label
                  htmlFor="reply-sig-individual"
                  className="mb-0 ms-1"
                  style={{
                    color: !currentUserSig?.staff_signature ? "var(--primary-25)" : "black",
                    fontWeight: "600",
                  }}
                >
                  Firm User Email Signature
                </label>
              </span>
              <div>
                {currentUserSig?.staff_signature ? (
                  <SignaturePreview signature={toPreviewProps(currentUserSig.staff_signature)} />
                ) : (
                  <div className="text-start text-grey p-2">No signature available</div>
                )}
              </div>
            </div>

            <div
              style={{
                width: "50%",
              }}
              className=" d-flex flex-column flex-g-1 justify-content-start"
            >
              <span className="d-flex align-items-center">
                <input
                  type="radio"
                  id="reply-sig-firm"
                  disabled={!currentUserSig?.firm_signature}
                  name="replySignatureType"
                  checked={signatureType === "firm"}
                  onChange={() => setSignatureType("firm")}
                />
                <label
                  htmlFor="reply-sig-firm"
                  style={{
                    color: !currentUserSig?.firm_signature ? "var(--primary-25)" : "black",
                    fontWeight: "600",
                  }}
                  className="mb-0 ms-1"
                >
                  Firm Email Signature
                </label>
              </span>
              <div>
                {currentUserSig?.firm_signature ? (
                  <SignaturePreview signature={toPreviewProps(currentUserSig.firm_signature)} />
                ) : (
                  <div className="text-start text-grey p-2">No signature available</div>
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <Button
              variant="secondary"
              className="height-25"
              style={{ padding: "0px 12px" }}
              onClick={() => {
                handleClose();
                addClickRecord(999, page_id_click_record);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="height-25"
              style={{ padding: "0px 12px" }}
              onClick={() => {
                addClickRecord(999, page_id_click_record);
                handleSubmit();
              }}
            >
              {loading ? "Sending.." : "Send Email"}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EmailReplyModal;
